import { inject, Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { StorageService } from '@client-monorepo/common/utilities';

@Injectable({
  providedIn: 'root',
})
export class SearchHistoryService {
  storageService = inject(StorageService);
  searchHistory = signal<Array<string>>([]);
  historyLoading = signal<boolean>(true);

  private getHistory(): Observable<Array<string>> {
    return new Observable((subscriber) => {
      const history = this.storageService.getSearchHistory();
      subscriber.next(history);
      subscriber.complete();
    });
  }

  refreshSearchHistory(): void {
    this.historyLoading.set(true);
    this.getHistory().subscribe({
      next: (result) => {
        this.searchHistory.set(result);
        this.historyLoading.set(false);
      },
    });
  }

  pushToSearchHistory(history: string) {
    this.getHistory().subscribe({
      next: (result) => {
        result.unshift(history);
        result = [...new Set(result)];
        this.storageService.setSearchHistory(result.slice(0, 5));
        this.refreshSearchHistory();
      },
    });
  }

  clearHistory(): void {
    this.storageService.setSearchHistory([]);
    this.refreshSearchHistory();
  }
}
